import axios from "axios";

import type {
  ILenderApplicationExtended,
  IOnboardingInput,
} from "../lender-applications/types/lender-application";
import type {
  ILenderResponse,
  ILenderResponseInput,
} from "./types/lender-response";
import type { IOfferAttractiveness } from "./types/offer-attractiveness";

export const placeBid = async (
  lenderCompanyId: number,
  lenderApplicationId: number,
  input: ILenderResponseInput,
) => {
  const response = await axios.post<ILenderApplicationExtended>(
    `/lender/api/v2/lender-companies/${lenderCompanyId}/lender-applications/${lenderApplicationId}/lender-responses`,
    input,
  );

  return response.data;
};

export const updateBid = async (
  lenderCompanyId: number,
  lenderApplicationId: number,
  lenderResponseId: number,
  input: ILenderResponseInput,
) => {
  const response = await axios.put<ILenderApplicationExtended>(
    `/lender/api/v2/lender-companies/${lenderCompanyId}/lender-applications/${lenderApplicationId}/lender-responses/${lenderResponseId}`,
    input,
  );

  return response.data;
};

export const deleteBid = async (
  lenderCompanyId: number,
  lenderApplicationId: number,
  lenderResponseId: number,
) => {
  const response = await axios.delete<ILenderApplicationExtended>(
    `/lender/api/v2/lender-companies/${lenderCompanyId}/lender-applications/${lenderApplicationId}/lender-responses/${lenderResponseId}`,
  );

  return response.data;
};

export const updateLenderResponseCreditTermsFile = async (
  lenderCompanyId: number,
  lenderResponseId: number,
  data: { file: File },
) => {
  const formData = new FormData();
  formData.append("file", data.file);

  const response = await axios.postForm<ILenderApplicationExtended>(
    `/lender/api/v2/lender-companies/${lenderCompanyId}/lender-responses/${lenderResponseId}/credit-terms-file`,
    formData,
  );

  return response.data;
};

export const lenderResponseMarkAsPaidOut = async (
  lenderCompanyId: number,
  lenderResponseId: number,
  input: ILenderResponseInput,
) => {
  const response = await axios.post<ILenderResponse>(
    `/lender/api/v2/lender-companies/${lenderCompanyId}/lender-responses/${lenderResponseId}/paid-out`,
    input,
  );

  return response.data;
};

export const changeOnboardingStep = async (
  lenderCompanyId: number,
  lenderResponseId: number,
  input: IOnboardingInput,
) => {
  const response = await axios.post<ILenderResponse>(
    `/lender/api/v2/lender-companies/${lenderCompanyId}/lender-responses/${lenderResponseId}/onboarding`,
    input,
  );

  return response.data;
};

export const getOfferAttractiveness = async (
  lenderCompanyId: number,
  lenderApplicationId: number,
  input: ILenderResponseInput,
) => {
  const response = await axios.post<IOfferAttractiveness>(
    `/lender/api/v2/lender-companies/${lenderCompanyId}/lender-applications/${lenderApplicationId}/lender-response-attractiveness`,
    input,
  );

  return response.data;
};

export const getLenderResponsePreview = async (
  lenderCompanyId: number,
  lenderApplicationId: number,
  input: ILenderResponseInput,
) => {
  const response = await axios.post<ILenderResponse>(
    `/lender/api/v2/lender-companies/${lenderCompanyId}/lender-applications/${lenderApplicationId}/lender-response-preview`,
    input,
  );

  return response.data;
};
